import { createSelector } from 'reselect';

export const appSelector = state => state.app;

export const changeBrowserModalVisibilitySelector = createSelector(
  appSelector,
  state => state.show_change_browser_modal
);



// WEBPACK FOOTER //
// ./src/app/modules/app/store/check-browser/selector.ts